import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IChipInput } from './chip.component.interface';

@Component({
    selector: 'mlp-ng-chip',
    templateUrl: './chip.component.html',
    styleUrls: ['./chip.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ChipSharedComponent {
    @Input() data: IChipInput;
    @Output() remove = new EventEmitter<boolean>();

    removeChip(): void {
        this.remove.emit(true);
    }
}
